export enum LocalStorage {
  CognitoAppClientId = 'cognito_app_client_id',
  ShowNotificationBannerForWorkRecommendedPage = 'showNotificationBannerForWorkRecommendedPage',
}

export enum SessionStorage {
  TempTenantCode = 'ffai_tenant_temp',
}
